import {
  CreditProgramKindSchema,
  OrganizationId,
  type PartnerProgramDomainSelectModel,
  PartnerProgramId,
} from '@mntn-dev/domain-types'
import { getRandomItem } from '@mntn-dev/utilities'
import { MockModel } from './mock-model.ts'

export const MockPartnerProgram = MockModel<PartnerProgramDomainSelectModel>(
  ({
    partnerProgramId = PartnerProgramId(),
    organizationId = OrganizationId(),
    creditProgramKind = getRandomItem(CreditProgramKindSchema.options),
    programMembershipId = undefined,
  }) => {
    return {
      partnerProgramId,
      organizationId,
      creditProgramKind,
      programMembershipId,
    } satisfies PartnerProgramDomainSelectModel
  }
)
